import React, {Component} from 'react';
import PropTypes from 'prop-types';
import * as R from 'ramda';
import {CONSTANTS} from 'js/common';
import {Tag} from '@social-native/snclient-ui';
import '@social-native/snclient-ui/dist/style.css';

const {PostTags} = CONSTANTS;

class ContentFiltersTabs extends Component {
    displayFilters() {
        const {
            changeIncludeContentFilter,
            changeExcludeContentFilter,
            includeContentFilters,
            excludeContentFilters
        } = this.props;

        return R.values(
            R.map(filter => {
                const parent = (
                    <Tag
                        key={filter}
                        label={filter}
                        color="gray"
                        size="small"
                        onDelete={() => changeIncludeContentFilter(filter)}
                    />                   
                );

                const tag = R.find(R.propEq('name', filter), R.values(PostTags.tree));
                const tagChildren = tag && tag.children ? R.values(tag.children) : [];
                const nonExcludedChildren = R.filter(
                    child => !R.contains(child, excludeContentFilters),
                    tagChildren
                );

                const children = R.map(
                    child => (
                        <Tag
                            key={child}
                            label={child}
                            color="gray"
                            size="small"
                            onDelete={() => changeExcludeContentFilter(child)}
                        />    
                    ),
                    nonExcludedChildren
                );

                return R.concat([parent], children);
            }, includeContentFilters)
        );
    }

    render() {
        const filters = this.displayFilters();

        if (!R.isEmpty(filters)) {
            return <div className="content-tags-wrapper">{filters}</div>;
        }
        return null;
    }
}

ContentFiltersTabs.propTypes = {
    changeIncludeContentFilter: PropTypes.func.isRequired,
    changeExcludeContentFilter: PropTypes.func.isRequired,
    excludeContentFilters: PropTypes.array.isRequired,
    includeContentFilters: PropTypes.array.isRequired
};

export default ContentFiltersTabs;



// WEBPACK FOOTER //
// ./campaign_analytics/v2/campaign_analytics_page/posts/content_filters_tabs.js